module.exports = __webpack_public_path__ + "static/media/undraw_project_complete_lwss.0fe76af9.svg";